"use client";

import {
  Box,
  Button,
  Dialog,
  Grid2,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@repo/ui";

import Image from "next/image";
import Section from "../components/Section";
import Icon from "@/components/Icon";
import { hasData } from "@/lib/helpers";
import DownloadBrochureForm from "@/components/forms/DownloadBrochureForm";
import { useState } from "react";

type AdvantagesOfSpoclearnProps = {
  sectionInfo: PageSections;
  data: {
    heading: string;
    subHeading: string;
    imageAltText: string;
    imagePath: string;
    buttonText: string;
    buttonAction: string;
    list: {
      icon: string;
      title: string;
      subTitle: string;
    }[];
  };
};

const AdvantagesOfSpoclearn = ({
  data,
  sectionInfo,
}: AdvantagesOfSpoclearnProps) => {
  const [open, setOpen] = useState(false);

  if (!hasData(data)) return null;

  return (
    <Section id={sectionInfo.sectionId} className={sectionInfo.sectionClass}>
      <Grid2 container spacing={5}>
        <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <Box>
            <Typography variant="h2" className="font-bold" gutterBottom>
              {data.heading}
            </Typography>
            {data.subHeading && (
              <Typography className="text-gray-500" paragraph>
                {data.subHeading}
              </Typography>
            )}

            <Box>
              <List>
                {data.list.map((item, index) => (
                  <ListItem key={`advantage-of-spoc-${index}`}>
                    <ListItemIcon className="pt-1">
                      <Icon
                        name={item.icon}
                        className="text-primary-main w-8 h-8"
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={item.title}
                      secondary={item.subTitle}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Box>
          <Box className="mt-7">
            <Button
              color="primary"
              variant="outlined"
              roundedFull
              label={data.buttonText}
              onClick={() => setOpen(true)}
            />
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <Box className="bg-gradient-to-b from-transparent from-80% to-slate-200 to-20% w-[fit-content] p-8 rounded-b-lg">
            <Image
              src={data.imagePath}
              width={460}
              height={394}
              alt={data.imageAltText}
              className="rounded-lg w-full h-auto"
            />
          </Box>
        </Grid2>
      </Grid2>

      {/* DownloadBrochure popUp */}
      <Dialog open={open} onOpenChange={setOpen} maxWidth="md" className="!p-0">
        <DownloadBrochureForm />
      </Dialog>
    </Section>
  );
};

export default AdvantagesOfSpoclearn;
